module.exports = __webpack_public_path__ + "img/frame_footer.1cbe5adb.svg";